export default __webpack_public_path__ + "static/media/wetest-logo-white.9e8af4ca.svg";